"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var theme_pricing_system_1 = require("../../../../theming/theme.pricing-system");

var section_view_1 = require("../../../primitives/section-view");

var heading_1 = require("../../text/heading/heading");

var Panel = function (_super) {
  __extends(Panel, _super);

  function Panel() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  Panel.prototype.render = function () {
    return react_1.default.createElement(section_view_1.SectionView, {
      style: [theme_pricing_system_1.pricingStyles.panelViewStyle, this.props.viewStyle]
    }, this.renderHeading(), this.props.children);
  };

  Panel.prototype.renderHeading = function () {
    if (!this.props.heading) {
      return null;
    }

    var defaultPanelLevel = 2;
    var level = this.props.level || defaultPanelLevel;
    return react_1.default.createElement(heading_1.Heading, {
      level: level,
      textStyle: [theme_pricing_system_1.pricingStyles.panelHeadingTextStyle, this.props.headingTextStyle]
    }, this.props.heading);
  };

  return Panel;
}(react_1.default.Component);

exports.Panel = Panel;